module.exports = function(app) {

    app.filter('EligibilityIndicator', function() {
        return function(code) {
            switch (code) {
                case '0': return 'Age';
                case '1': return 'Disability';
                case '2': return 'End Stage Renal Disease';
                case '3': return 'Disability and End Stage Renal Disease';

            }
        };
    });

};


